module.exports = __webpack_public_path__ + "static/media/296347.67c88dc5.png";